import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-inputicon'
};

export default BaseStyle.extend({
    name: 'inputicon',
    classes
});
